import {
  ADD_FAVOURITE_PROJECT,
  ADD_FAVOURITE_PROJECT_SUCCESS,
  FETCH_PROJECT,
  FETCH_PROJECT_SUCCESS,
  FETCH_ALL_PROJECT,
  FETCH_ALL_PROJECT_SUCCESS,
  FILTER_PROJECT,
  GET_ALL_PROJECT,
  GET_UNSELECTED_ALL_PROJECT,
  HANDLE_PROJECT_REQUEST_CLOSE,
  HIDE_PROJECT_LOADER,
  SHOW_PROJECT_LOADER,
  ON_ADD_PROJECT,
  ON_ALL_PROJECT_SELECT,
  ON_PROJECT_CLOSE,
  ON_PROJECT_SELECT,
  ON_DELETE_PROJECT,
  ON_DELETE_PROJECT_SUCCESS,
  ON_DELETE_SELECTED_PROJECT,
  ON_FILTER_PROJECT_OPTION_SELECT,
  ON_SAVE_PROJECT,
  ON_SAVE_PROJECT_SUCCESS,
  ON_TOGGLE_PROJECT_DRAWER,
  SHOW_PROJECT_MESSAGE,
  UPDATE_SEARCH_PROJECT,
  ON_PROJECT_COST_PRIORITIES_DASHBOARD,
  ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD,
  ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD,
  ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD,
  ON_PROJECT_PRIORITY_DASHBOARD,
  FETCH_IMPORT_PROJECTS,
  FETCH_IMPORT_PROJECTS_SUCCESS,
  SHOW_IMPORT_PROJECTS_LOADER,
  HIDE_IMPORT_PROJECTS_LOADER,
  ON_IMPORT_PROJECTS,
  ON_IMPORT_PROJECTS_SUCCESS,
  ON_PROJECT_ISSUES_DASHBOARD,
  ON_SAVE_PROJECT_CACHE_SUCCESS,
  SET_PROJECT,
} from 'constants/ActionTypes';

export const setProject = (payload) => {
  return {
      type: SET_PROJECT,
      payload
  };
};
export const onSaveProjectCacheSuccess = (payload) => {
  return {
      type: ON_SAVE_PROJECT_CACHE_SUCCESS,
      payload
  };
};
export const onImportProjects = () => {
  return {
      type: ON_IMPORT_PROJECTS
  };
};
export const onImportProjectsSuccess = (payload) => {
  return {
      type: ON_IMPORT_PROJECTS_SUCCESS,
      payload
  };
};
export const fetchImportProjects = (payload) => {
  return {
      type: FETCH_IMPORT_PROJECTS,
      payload
  };
};
export const fetchImportProjectsSuccess = (payload) => {
  return {
      type: FETCH_IMPORT_PROJECTS_SUCCESS,
      payload
  };
};
export const showImportProjectsLoader = () => {
  return {
      type: SHOW_IMPORT_PROJECTS_LOADER,
  };
};
export const hideImportProjectsLoader = () => {
  return {
      type: HIDE_IMPORT_PROJECTS_LOADER,
  };
};
export const onProjectIssuesDashboard = (payload) => {
  return {
      type: ON_PROJECT_ISSUES_DASHBOARD,
      payload
  };
};
export const onProjectPrioritiesDashboard = (payload) => {
  return {
      type: ON_PROJECT_PRIORITY_DASHBOARD,
      payload
  };
};
export const onProjectCostPrioritiesDashboard = (payload) => {
  return {
      type: ON_PROJECT_COST_PRIORITIES_DASHBOARD,
      payload
  };
};
export const onProjectBusinessPrioritiesDashboard = (payload) => {
  return {
      type: ON_PROJECT_BUSINESS_PRIORITIES_DASHBOARD,
      payload
  };
};
export const onGlobalProjectCostPrioritiesDashboard = (payload) => {
  return {
      type: ON_GLOBAL_PROJECT_COST_PRIORITIES_DASHBOARD,
      payload
  };
};
export const onGlobalProjectBusinessPrioritiesDashboard = (payload) => {
  return {
      type: ON_GLOBAL_PROJECT_BUSINESS_PRIORITIES_DASHBOARD,
      payload
  };
};
export const fetchProject = (payload) => {
  return {
      type: FETCH_PROJECT,
      payload
  };
};
export const fetchProjectSuccess = (payload) => {
  return {
      type: FETCH_PROJECT_SUCCESS,
      payload
  };
};
export const fetchProjects = (payload) => {
  return {
      type: FETCH_ALL_PROJECT,
      payload
  };
};
export const fetchProjectsSuccess = (payload) => {
  return {
      type: FETCH_ALL_PROJECT_SUCCESS,
      payload
  };
};
export const showProjectMessage = (message) => {
  return {
      type: SHOW_PROJECT_MESSAGE,
      payload: message
  };
};
export const addFavouriteProject = (payload) => {
  return {
      type: ADD_FAVOURITE_PROJECT,
      payload
  };
};
export const addFavouriteProjectSuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_PROJECT_SUCCESS,
      payload
  };
};
export const onProjectSelect = (payload) => {
  return {
      type: ON_PROJECT_SELECT,
      payload
  };
};
export const onAddProject = () => {
  return {
      type: ON_ADD_PROJECT,
      payload: ''
  };
};
export const onProjectClose = () => {
  return {
      type: ON_PROJECT_CLOSE,
      payload: ''
  };
};
export const onFilterProjectOptionSelect = (payload) => {
  return {
      type: ON_FILTER_PROJECT_OPTION_SELECT,
      payload
  };
};
export const onSaveProject = (payload) => {
  return {
      type: ON_SAVE_PROJECT,
      payload
  };
};
export const onSaveProjectSuccess = (payload) => {
  return {
      type: ON_SAVE_PROJECT_SUCCESS,
      payload
  };
};
export const onDeleteProject = (payload) => {
  return {
      type: ON_DELETE_PROJECT,
      payload
  };
};
export const onDeleteProjectSuccess = (payload) => {
  return {
      type: ON_DELETE_PROJECT_SUCCESS,
      payload
  };
};
export const onDeleteSelectedProject = () => {
  return {
      type: ON_DELETE_SELECTED_PROJECT,
      payload: ''
  };
};
export const filterProject = (payload) => {
  return {
      type: FILTER_PROJECT,
      payload
  };
};
export const getAllProject = () => {
  return {
      type: GET_ALL_PROJECT,
      payload: ''
  };
};
export const getUnselectedAllProject = () => {
  return {
      type: GET_UNSELECTED_ALL_PROJECT,
      payload: ''
  };
};
export const onAllProjectSelect = () => {
  return {
      type: ON_ALL_PROJECT_SELECT,
      payload: ''
  };
};
export const updateSearchProject = (payload) => {
  return {
      type: UPDATE_SEARCH_PROJECT,
      payload
  };
};
export const onToggleProjectDrawer = () => {
  return {
      type: ON_TOGGLE_PROJECT_DRAWER,
  };
};
export const handleProjectRequestClose = () => {
  return {
      type: HANDLE_PROJECT_REQUEST_CLOSE,
  };
};
export const showProjectLoader = () => {
  return {
      type: SHOW_PROJECT_LOADER,
  };
};
export const hideProjectLoader = () => {
  return {
      type: HIDE_PROJECT_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/project.js